import { bare } from "./axios";
import {
  ConferirLinkResponse,
  DefinirSenhaRequest,
  DefinirSenhaResponse,
  EsqueciRequest,
  EsqueciResponse,
} from "../interfaces/Auth";

/**
 * Rotas anônimas de Auth. Usam o cliente `bare` (sem interceptor): não há sessão a renovar e um
 * 401 aqui não pode disparar o fluxo de refresh.
 */
export async function esqueciSenha(email: string): Promise<EsqueciResponse> {
  const corpo: EsqueciRequest = { email };
  const { data } = await bare.post<EsqueciResponse>("/Auth/Esqueci", corpo);
  return data;
}

export async function conferirLink(token: string): Promise<ConferirLinkResponse> {
  const { data } = await bare.post<ConferirLinkResponse>("/Auth/Link/Conferir", { token });
  return data;
}

export async function definirSenha(token: string, novaSenha: string): Promise<DefinirSenhaResponse> {
  const corpo: DefinirSenhaRequest = { token, novaSenha };
  const { data } = await bare.post<DefinirSenhaResponse>("/Auth/DefinirSenha", corpo);
  return data;
}
